/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .radio-group {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .action-container {
    gap: 1rem;
    display: flex;
    justify-content: flex-end;
  }

`;

export {
  FormContainer,
};
